module.exports = __webpack_public_path__ + "img/icon_material_cumulative_qk_2.a6b4b524.webp";